/**
 @description: description
 @date: 2018/10/16
 @author: 雷利(Rayleight@baie.com.cn)
 */

export function RNMAKF(userName, phone) {
    window.location.href = `http://ebossim.rosepie.com/webchat/jsp/standard/interfacePools.jsp?from=YC1&queue=10&device=mobile&userName=${userName}&phone=${phone}`
}
